<template>
    <section>
        <h4>Set up your Huawei</h4>
        <p>B525 / B618</p>
        <p class="sub-text">The Access Point Name (APN) on your Huawei modem will have to be changed before you can use the <span v-html="provider"></span> services. Please follow the steps below to get connected.</p>
        <div class="divider"></div>
        <div class="config-steps">
            <config-step v-for="step in steps" :step="step"></config-step>
            <p class="foot-note">Your services should be active within 30 minutes, but may take up to 48 hours.</p>
        </div><!-- end.config-steps -->
        <section-footer
            :buttons="buttons"
            @next="startOver()">
        </section-footer>
    </section>
</template>

<script>
    import ConfigStep from '@/components/ConfigStep'
    import SectionFooter from '@/components/SectionFooter'

    export default {
        components: {
            ConfigStep,
            SectionFooter,
        },
        computed: {
            provider() {
                let provider = this.$store.getters['provider'];
                return provider === 'pure-lte' ? 'Pure&nbsp;LTE' : 'Telkom LTE';
            },
            buttons() {
                return [
                    {
                        label: 'Start Again',
                        event: 'next',
                        class: '',
                        disabled: false
                    }
                ]
            }
        },
        methods: {
            startOver() {
                this.$store.commit('reset');
                this.$router.push({name: 'home'});
            }
        },
        data() {
            return {
                steps: [
                    {
                        title: 'Installing the SIM card',
                        steps: [
                            {
                                content: 'Carefully push out the correct size SIM for your device.',
                                subSteps: false
                            },
                            {
                                content: 'Insert the SIM card into the modem. Make sure the SIM faces the right direction.',
                                subSteps: false
                            },
                        ]
                    },
                    {
                        title: 'Power up the modem',
                        steps: [
                            {
                                content: 'Plug the modem into a wall socket and switch it on.',
                                subSteps: false
                            }
                        ]
                    },
                    {
                        title: 'Connect your modem to your computer',
                        steps: [
                            {
                                content: 'Connect your modem to your computer to the LAN port via Ethernet cable.',
                                subSteps: false
                            }
                        ]
                    },
                    {
                        title: 'Open your modem\'s web management page',
                        steps: [
                            {
                                content: 'Open your preferred web browser (Chrome, Firefox, Safari, Edge, etc.) on your computer.',
                                subSteps: false
                            },{
                                content: 'Enter the following URL in the address bar - <strong>http://192.168.8.1</strong>',
                                subSteps: false
                            },{
                                content: 'Enter the username and password of your modem.',
                                subSteps: false
                            },
                        ]
                    },
                    {
                        title: 'Change your APN settings',
                        steps: [
                            {
                                content: "Click on the Settings tab.",
                                subSteps: false
                            },
                            {
                                content: "You will be asked for your username and password.",
                                subSteps: false
                            },
                            {
                                content: "Under 'Dial-up' on the right-hand side, select 'Profile Management'.",
                                subSteps: false
                            },
                            {
                                content: "Click on the 'New Profile' button.",
                                subSteps: false
                            },
                            {
                                content: 'In the New Profile section, enter the following details:',
                                subSteps: [
                                    'Profile name: afrihost',
                                    'Username and Password: (leave these blank)',
                                    'IP Type: IPv4',
                                    'APN: <strong>ws.afrihost.fwa</strong> (all lower case, no spaces)'
                                ]
                            },
                            {
                                content: "Click on the 'Save' button.",
                                subSteps: false
                            },
                            {
                                content: "You will be sent back to the Profile Management page.",
                                subSteps: false
                            },
                            {
                                content: "Make sure your select 'afrihost' in the Profile name dropdown, then click 'Save and Apply'.",
                                subSteps: false
                            }
                        ]
                    }
                ]
            }
        },
        mounted() {
            // let accordions = document.querySelectorAll('.config-step p');
            // accordions.forEach(a => {
            //     a.addEventListener('click', e => {
            //         e.target.classList.toggle('is-open');
            //     });
            // });
        }
    }
</script>